module.exports = __webpack_public_path__ + "img/logoHeader.53d44c3c.png";